var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { canUseDOM } from 'exenv';
import { defaultTheme } from '@food/css-manager';
var LayoutHandler = /** @class */ (function (_super) {
    __extends(LayoutHandler, _super);
    function LayoutHandler(props) {
        var _this = _super.call(this, props) || this;
        var layouts = _this.props.layouts;
        var width = canUseDOM
            ? window.innerWidth
            : defaultTheme.breakpoints.mobileMax - 1;
        _this.state = Object.keys(layouts).reduce(function (state, key) {
            state[key] = layouts[key](width);
            return state;
        }, {});
        return _this;
    }
    LayoutHandler.prototype.layoutHandler = function () {
        var _this = this;
        var layouts = this.props.layouts;
        var width = canUseDOM
            ? window.innerWidth
            : defaultTheme.breakpoints.mobileMax - 1;
        var possibleChanges = {};
        if (!layouts) {
            return;
        }
        Object.keys(layouts).forEach(function (key) {
            possibleChanges[key] = layouts[key](width);
        });
        var changesKeys = Object.keys(possibleChanges).filter(function (key) { return possibleChanges[key] !== _this.state[key]; });
        if (changesKeys.length !== 0) {
            var changes = changesKeys.reduce(function (prev, key) {
                prev[key] = possibleChanges[key];
                return prev;
            }, {});
            this.setState(changes);
        }
    };
    LayoutHandler.prototype.componentDidMount = function () {
        var _this = this;
        if (canUseDOM) {
            this.windowListener = window.addEventListener('resize', function () {
                return _this.layoutHandler();
            });
        }
    };
    LayoutHandler.prototype.componentWillUnmount = function () {
        if (canUseDOM) {
            removeEventListener('resize', this.windowListener);
        }
    };
    LayoutHandler.prototype.render = function () {
        var children = this.props.children;
        return children(this.state);
    };
    return LayoutHandler;
}(React.Component));
export { LayoutHandler };
//# sourceMappingURL=LayoutHandler.js.map